import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AssistantConversationQuery } from "../graphql/queries";
import type {
  AssistantConversationQueryType,
  AssistantConversationQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAssistantConversationQuery = (
  options?: QueryHookOptions<
    AssistantConversationQueryType,
    AssistantConversationQueryVariablesType
  >
) => {
  return useQuery<
    AssistantConversationQueryType,
    AssistantConversationQueryVariablesType
  >(AssistantConversationQuery, options);
};
